
    import * as React from 'react';

    const Ruler24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M2 13.5L18.454 4l3.5 6.062-16.454 9.5L2 13.5zm1.366.366l2.5 4.33 14.722-8.5-2.5-4.33-14.722 8.5zm1.732-1l.866-.5 1.5 2.598-.866.5-1.5-2.598zm7.794-4.5l.866-.5 1 1.732-.866.5-1-1.732zm-2.598 1.5l.866-.5 1.5 2.598-.866.5-1.5-2.598zm5.196-3l.866-.5 1.5 2.598-.866.5-1.5-2.598zm-7.794 4.5l.866-.5 1 1.732-.866.5-1-1.732z" /></svg>
        </div>
      );
    };

    Ruler24.displayName = 'Ruler24';

    export default Ruler24;
  